import Permissions, { usePermissions } from '@app/src/auth/permissions'
import ValueCell from '@app/src/components/Table/Cells/ValueCell'
import type { ProviderProgressView } from '@app/src/types/resourceExplorer'
import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import ProviderProgressCell from './ProviderProgressCell'
import TrendCell from './TrendCell'

interface ProviderProgressRowProps {
  row: ProviderProgressView
  periods: string[]
  organizationId?: number
}

const ProviderProgressRow: React.FC<ProviderProgressRowProps> = ({
  row: providerProgressView,
  periods,
  organizationId,
}) => {
  const { hasPermission } = usePermissions()
  return (
    <TableRow data-cy="provider-progress-row">
      <TableCell>{providerProgressView?.parentObject.title}</TableCell>

      {periods.map(period => (
        <ProviderProgressCell
          key={`${providerProgressView.parentObject?.id}-${period}`}
          periodDetail={providerProgressView.periodDetails.find(detail => detail.periodName === period)}
        />
      ))}

      <ValueCell value={providerProgressView.parentObject?.unit?.symbol ?? ''} />
      {!hasPermission(Permissions.TRANSPARENCY_USER) && (
        <TrendCell
          questionType={providerProgressView.parentObject?.questionType}
          isMultiSelectOptionQuestion={providerProgressView.periodDetails[0]?.isMultiSelectOptionQuestion}
          providerProgressViewData={providerProgressView}
          periods={periods}
          organizationId={organizationId}
        />
      )}
    </TableRow>
  )
}

export default ProviderProgressRow
